import { Flex } from '@chakra-ui/react';
import { observer } from 'mobx-react-lite';

import NavigationLinkItem from '@features/marketplace/navigation/NavigationLinkItem';
import { useMarketplaceNavigationEntities } from 'hooks/useNavigationEntities';

const NavigationLinks = () => {
  const { root, byId } = useMarketplaceNavigationEntities();
  return (
    <Flex flexDirection="row" gap={4}>
      {root.children.map((child) => {
        const entity = byId[child.id];
        return <NavigationLinkItem key={entity.id} entity={entity} />;
      })}
    </Flex>
  );
};

export default observer(NavigationLinks);
